import {Component} from "react";
import styles from './Pages.module.scss';
import ExternalHTMLContent from "../ExternalHTMLContent";
import {Box, Typography} from "@material-ui/core";

export interface ExternalPageProps {
    /** PageData puede llegar sin titulo ni cuerpo. @see PageData */
    title?: string;
    pageHtml?: string;
}

class ExternalPage extends Component<ExternalPageProps> {

    render() {
        return <div className={styles.page + ' page'}>
            <div className={styles.header + ' header'}>
                <Typography variant="h1" component="h1">
                    { this.props.title }
                </Typography>
            </div>
            <Box p={3}>
                <ExternalHTMLContent contentHtml={this.props.pageHtml} />
            </Box>
        </div>
    }
}

export default ExternalPage;
